// 该顺序不能动，是底部按钮下一个方案的顺序依据
export const dataList = [
  { // 下一个方案跳转时用到,但因为crm页面结构不同,用单独另一个配置
    pathUrl: '/solution/crm',
    pathName: '销冠CRM',
    footerSubTitle: '赋能超级个体，成就百万销冠',
    title: '快速构建线上营销阵地，打造流畅的买房卖房体验',
  },
  { // 营销云页面配置
    pathUrl: '/solution/marketing-cloud',
    pathName: '营销云',
    footerSubTitle: '全渠道营销管理平台，让营销更智能、更高效',
    title: '全渠道营销管理平台，让营销更智能、更高效',
  },
  {
    pathUrl: '/solution/channel-manage',
    pathName: '渠道管理',
    title: '强化企业渠道管控能力，赋能全渠道高效运转',
    dataInfo: [
      {
        direction: 'left',
        title: '全渠道判客',
        subtitle: '更快速智能的渠道判客机制',
        link: '/index',
        list: [
          '灵活设定报备到认购全阶段规则，辅助快速溯源',
          '报备即可实时判客，清晰归属及时跟进',
          '支持发起判客申诉，有效调解归属纠纷',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-four.png',
      },
      {
        direction: 'right',
        title: '自渠拓客',
        subtitle: '精细化自渠管理，提升规模获客转化',
        link: '/index',
        list: [
          '快速搭建渠道体系，外拓人员统一管理',
          '规范客户报备到跟进全流程规则，精细化管控洞察',
          '策渠一体联动，内容/活动有效穿透，客户轨迹实时可循',
          '提供拓客码等多样化推客工具，助力行销拓客',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
      },
      {
        direction: 'left',
        title: '分销管理',
        subtitle: '规范分销机构运作流程，提升分销管理效率',
        link: '/index',
        list: [
          '支持多分销机构，统一入口集中管理',
          '不同渠道对应不同规则，灵活设定高效合作',
          '从报备、判客到跟进，透明渠道流程防飞单',
          '渠道数据智能分析，助力优化成交结构',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-two.png',
      },
      {
        direction: 'right',
        title: '全民营销',
        subtitle: '助力规模化低成本获客',
        link: '/index',
        list: [
          '建立经纪人工作台，报备到结佣全流程可视化',
          '搭建经纪人自裂变网络，实现二级分佣',
          '在线快速结佣，激发经纪人推客动力',
          '分享推荐积分赚积分，实现过程激励',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-three.png',
      },
      {
        direction: 'left',
        title: '快速结佣',
        subtitle: '比渠道公司更快、更高效的结佣方式',
        link: '/index',
        list: [
          '线上一键发放，7天快速结佣',
          '全流程可视化，实时跟踪进度',
          '到手佣金更多，推客更有动力',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-six.png',
      },
      {
        direction: 'right',
        title: '渠道风控',
        subtitle: '多重核验预警提示，守好每一道飞单防线',
        link: '/index',
        list: [
          '监控推荐到成交全流程数据，实现8大风险类型校验',
          '客户到访过程及轨迹全程记录，精准判别风险',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-five.png',
      },
    ],
  },
  {
    pathUrl: '/solution/member-marketing',
    pathName: '会员营销',
    title: '会员价值增长引擎助力线上商城创收、内容营销种草、活动营销引爆、积分体系促活',
    dataInfo: [
      {
        direction: 'left',
        title: '线上商城',
        subtitle: '支撑全域商品线上交易的增收利器',
        link: '/index',
        list: [
          '支持自有商品、微信小店商品、京东商品等多商品体系',
          '商城支持关联分销体系&会员体系',
          '线上交易&线下门店承接-双轮驱动增长',
        ],
        image:
          require('@/assets/img/产品功能图片/线上商城.png'),
      },
      {
        direction: 'right',
        title: '内容营销',
        subtitle: '内容驱动的智能营销引擎',
        link: '/index',
        list: [
          '多样化传播物料，覆盖拓客全场景',
          '一物一码多途径管理，便捷溯源优化',
          '细颗粒度数据采集，获取轨迹挖掘潜客',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
      },
      {
        direction: 'left',
        title: '营销活动',
        subtitle: '优秀活动一键复用，玩法多样快速组合',
        link: '/index',
        list: [
          '7000+高品质活动模板，一键套用快速获客',
          '5级玩法嵌套满足复杂营销需求，契合95%的营销节点',
          '"拖-拉-拽"快速配置活动，上线效率提升4倍以上',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-three.png',
      },
      {
        direction: 'right',
        title: '积分运营',
        subtitle: '分层任务体系，裂变激励兑换，赋能多业务场景',
        link: '/index',
        list: [
          '不同角色设置多样任务和积分体系，分层促活',
          '用户转发裂变进行积分激励，提高用户粘性',
          '商城上架实物、卡券等多样化礼品，用户可进行积分兑换，提升客户活跃度',
          '结合分享报备、全民营销、案场服务、预约场馆，运用积分运营扩展更多业务场景',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/precipitate-two.png',
      },

    ],
  },
  {
    pathUrl: '/industry/automotive',
    pathName: '汽车行业解决方案',
    title: '汽车经销商数字化营销解决方案，赋能智慧营销新时代',
    dataInfo: [
      {
        direction: 'left',
        title: '优化对客门户',
        link: '/index',
        list: [
          '线上门店：精美设计官方门户，展示产品与服务',
          '销售道具：多元物料库（智能名片、直播工具等），精准触达客户',
          '营销活动：多样化玩法（如88元特惠活动），数据可追溯'
        ],
        image: require('@/assets/img/汽车行业解决方案配图/优化对客门户.jpg'),
      },
      {
        direction: 'right',
        title: '助力销售转化',
        // subtitle: '销冠CRM',
        link: '/index',
        list: [
          '移动化操作界面，提升销售跟进效率',
          '智能沟通：记录销客对话，AI分析自动生成跟进记录（如智能工牌）',
          '自动化运营：任务设计激活客户，提升留存率'
        ],
        image: require('@/assets/img/汽车行业解决方案配图/助力销售转化.png'),
      },
      {
        direction: 'left',
        title: '强化管理抓手',
        // subtitle: '营销云',
        link: '/index',
        list: [
          '过程管理：数据复现销售流程，实时监控跟进情况',
          '增值功能：智能外呼、IM即时沟通，提升客户触达效率'
        ],
        image: require('@/assets/img/汽车行业解决方案配图/强化管理抓手.jpg'),
      },
    ],
  },
  {
    pathUrl: '/industry/real-estate',
    pathName: '房地产行业解决方案',
    title: '房地产企业数字化营销解决方案，赋能智慧地产新发展',
    dataInfo: [
      {
        direction: 'left',
        title: '销冠CRM',
        subtitle: '赋能超级个体，成就百万销冠',
        link: '/index',
        list: [
          '拓客利器：电子名片+物料库+营销活动+发抖音，全方位拓客工具',
          'AI应用：AI数字人+内容创作+AIdee，智能化营销助手',
          '客户管理：跟客助手+客户洞察，实时跟客闭环管理',
          '团队协作：招募经纪人+经营看板+销售排行榜，数据驱动经营',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-crm.png',
      },
      {
        direction: 'right',
        title: '智慧案场',
        subtitle: '营销一体化数字案场解决方案',
        link: '/index',
        list: [
          '高效渠道管理，强化房企渠道管控能力，赋能全渠道高效运转',
          '智慧案场，高效规范案场服务及销售过程，实现案场数字化升级',
          '智慧交易，低成本、轻量化搭建的交易管理系统，助力交易效率快速提升',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-smart.png',
      },
      {
        direction: 'left',
        title: '营销云',
        subtitle: '赋能数字营销，更赋能数字管理',
        link: '/index',
        list: [
          '案场管理：标准化销售过程，精细化客户管理，实现数字化升级',
          '智能工牌：结合GPT技术智能复盘客户沟通，优化服务质量',
          '渠道风控与交易：全渠道管理与智慧交易系统，提升成交效率',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-market.png',
      },
      {
        direction: 'right',
        title: '数字沙盘',
        subtitle: '楼盘方寸间，看房零局限',
        link: '/index',
        list: [
          'UE5大屏，三维交互仿真场景，带给用户超越真实的场景体验',
          'iPad移动售楼系统，随时随地沉浸式看房、选房、游览社区环境体',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-sand.png',
      },
    ],
  },
  {
    pathUrl: '/industry/healthcare',
    pathName: '大健康行业解决方案',
    title: '大健康企业数字化营销解决方案，赋能健康产业新发展',
    dataInfo: [
      {
        direction: 'left',
        title: '品牌展示',
        subtitle: '多维立体品牌空间，强化用户认知与归属感',
        link: '/index',
        list: [
          '官方小程序品牌展览，统一流量收口，集成VR/视频/图文等多维展示',
          '内置产品展示、预约体验、线上咨询等功能，实时响应客户需求',
          '全埋点追踪行为，捕捉真实用户意向'
        ],
        image:require('@/assets/img/产品功能图片/品牌展示-健康.png'),
      },
      {
        direction: 'right',
        title: '销售提效',
        subtitle: '赋能超级个体，成就百万销冠',
        link: '/index',
        list: [
          '拓客利器：电子名片+物料库+营销活动+发抖音，全方位拓客工具',
          'AI应用：AI数字人+AI内容创作+AIdee，智能化营销助手',
          '客户管理：跟客助手+客户洞察，实时跟客闭环管理',
          '团队协作：招募经纪人+经营看板+销售排行榜，数据驱动经营'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-crm.png',
      },
      {
        direction: 'left',
        title: '会员运营',
        subtitle: '以 "权益互通 + 分层运营 + 分享裂变" 为驱动，构建私域会员增长闭环，激活会员价值',
        link: '/index',
        list: [
          '不同角色可独立配置专属会员体系，可通过积分兑换礼品、参与社群活动，持续活跃会员',
          '推出储值加赠、生日特权等专属活动，强化身份尊贵感',
          '设计 "分享得积分""拉新升级会员" 玩法，借助社交链扩大流量'
        ],
        image:require('@/assets/img/产品功能图片/会员运营-健康.png'),
      },
      {
        direction: 'right',
        title: '数据管理',
        subtitle: '一体化平台数据管理，为一线业务提供指导意义的数据报表',
        link: '/index',
        list: [
          '集成全域数据，打造1+3可视化分析平台，支撑营销决策',
          '数据可联动+透视各个项目，全方位系统分析',
          '一次建模长期复用，数据处理效率大幅提升',
          '满足团队协作、项目管理，数据协作等多重场景'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/insight-three.png',
      }
    ],
  },
  {
    pathUrl: '/industry/education',
    pathName: '教育行业解决方案',
    title: '教育行业高客单价解决方案，赋能教育产业新发展',
    dataInfo: [
      {
        direction: 'left',
        title: '品牌展示',
        subtitle: '多维立体品牌空间，强化用户认知与归属感',
        link: '/index',
        list: [
          '官方小程序品牌展览，统一流量收口，集成VR/视频/图文等多维展示',
          '内置产品展示、预约体验、线上咨询等功能，实时响应客户需求',
          '全埋点追踪行为，捕捉真实用户意向'
        ],
        image: require('@/assets/img/产品功能图片/品牌展示-教育.png'),
      },
      {
        direction: 'right',
        title: '课程售卖',
        subtitle: '支持全域课程商品线上交易的增收利器',
        link: '/index',
        list: [
          '支持上线自有商品、课程进行售卖',
          '商城支持关联分销体系&会员体系',
          '线上交易&线下门店承接-双轮驱动增长'
        ],
        image: require('@/assets/img/产品功能图片/课程售卖-教育.png'),
      },
      {
        direction: 'left',
        title: '多渠道获客',
        subtitle: '整合公域、私域、裂变分销多通路，通过智能工具全域捕捉高价值客群',
        link: '/index',
        list: [
          'AI生成多平台内容、AI剪辑短视频并同步发布获客',
          '精准投放广告，覆盖腾讯广告、百度营销、巨量引擎等主流平台，统一线索管理，优化策略提精准度',
          '小程序支持扫码裂变，全民营销工作台助力分销，激发推客动力，扩大线索范围'
        ],
        image:require('@/assets/img/产品功能图片/全渠道获客.png'),
      },
      {
        direction: 'right',
        title: '会员运营',
        subtitle: '以 "权益互通 + 分层运营 + 分享裂变" 为驱动，构建私域会员增长闭环，激活会员价值',
        link: '/index',
        list: [
          '不同角色可独立配置专属会员体系，可通过积分兑换礼品、参与社群活动，持续活跃会员',
          '推出储值加赠、生日特权等专属活动，强化身份尊贵感',
          '设计 "分享得积分""拉新升级会员" 玩法，借助社交链扩大流量'
        ],
        image: require('@/assets/img/产品功能图片/会员运营-教育.png'),
      },
      {
        direction: 'left',
        title: '销售提效',
        subtitle: '赋能超级个体，成就百万销冠',
        link: '/index',
        list: [
          '拓客利器：电子名片+物料库+营销活动+发抖音，全方位拓客工具',
          'AI应用：AI数字人+AI内容创作+AIdee，智能化营销助手',
          '客户管理：跟客助手+客户洞察，实时跟客闭环管理',
          '团队协作：招募经纪人+经营看板+销售排行榜，数据驱动经营'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-crm.png',
      },
      {
        direction: 'right',
        title: '数据管理',
        subtitle: '一体化平台数据管理，为一线业务提供指导意义的数据报表',
        link: '/index',
        list: [
          '集成全域数据，打造1+3可视化分析平台，支撑营销决策',
          '数据可联动+透视各个项目，全方位系统分析',
          '一次建模长期复用，数据处理效率大幅提升',
          '满足团队协作、项目管理，数据协作等多重场景'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/insight-three.png',
      }
    ],
  },
  {
    pathUrl: '/industry/home-decoration',
    pathName: '家装行业解决方案',
    title: '家装企业数字化营销解决方案，赋能家装产业新发展',
    dataInfo: [
      {
        direction: 'left',
        title: '多渠道获客',
        subtitle: '整合公域、私域、裂变分销多通路，通过智能工具全域捕捉高价值客群',
        link: '/index',
        list: [
          'AI生成多平台内容、AI剪辑短视频并同步发布获客',
          '精准投放广告，覆盖腾讯广告、百度营销、巨量引擎等主流平台，统一线索管理，优化策略提精准度',
          '小程序支持扫码裂变，全民营销工作台助力分销，激发推客动力，扩大线索范围'
        ],
        image: require('@/assets/img/产品功能图片/全渠道获客.png'),
      },
      {
        direction: 'right',
        title: '品牌展示',
        subtitle: '多维立体品牌空间，强化用户认知与归属感',
        link: '/index',
        list: [
          '官方小程序品牌展览，统一流量收口，集成VR/视频/图文等多维展示',
          '内置产品展示、预约体验、线上咨询等功能，实时响应客户需求',
          '全埋点追踪行为，捕捉真实用户意向'
        ],
        image: require('@/assets/img/产品功能图片/品牌运营中枢.png'),
      },
      {
        direction: 'left',
        title: '客户运营',
        subtitle: '精准识别客户意向，辅助决策运营',
        link: '/index',
        list: [
          '基于任务+Ai云Call，智能快捷识别客户意向',
          '洞悉客群属性和行为，精准预测客户生命周期阶段',
          '基于全渠道数据埋点，生成360度描摹，还原客户真实画像'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-four.png',
      },
      {
        direction: 'right',
        title: '销售提效',
        subtitle: '赋能超级个体，成就百万销冠',
        link: '/index',
        list: [
          '拓客利器：电子名片+物料库+营销活动+发抖音，全方位拓客工具',
          'AI应用：AI数字人+AI内容创作+AIdee，智能化营销助手',
          '客户管理：跟客助手+客户洞察，实时跟客闭环管理',
          '团队协作：招募经纪人+经营看板+销售排行榜，数据驱动经营'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/home-crm.png',
      },
      {
        direction: 'left',
        title: '数据管理',
        subtitle: '一体化平台数据管理，为一线业务提供指导意义的数据报表',
        link: '/index',
        list: [
          '集成全域数据，打造1+3可视化分析平台，支撑营销决策',
          '数据可联动+透视各个项目，全方位系统分析',
          '一次建模长期复用，数据处理效率大幅提升',
          '满足团队协作、项目管理，数据协作等多重场景'
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/insight-three.png',
      },
    ],
  },
  {
    pathUrl: '/solution/omnichannel-acquisition',
    pathName: '全渠道获客',
    title: 'AI获客',
    dataInfo: [
      {
        direction: 'left',
        title: 'AIGC内容获客',
        subtitle: 'AIGC内容生产：快速批量化文案创作，爆文信手拈来',
        link: '/index',
        list: [
          '小红书文案、短视频脚本、直播脚本等多类型新媒体文案',
          '一键二次原创，实现高效、高质量的内容生产',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-fouer.png',
      },
      {
        direction: 'right',
        title: 'AI短视频',
        subtitle: 'AI智能剪辑+矩阵自动分发，可批量多人快速传播',
        link: '/index',
        list: [
          '高效创作快速裂变上千+个视频',
          '全员抖音账号自动发布占据流量',
          '小红书、快手一键发布',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
      },
      {
        direction: 'left',
        title: 'AI视频工厂',
        subtitle: '优秀活动一键复用，玩法多样快速组合',
        link: '/index',
        list: [
          '5分钟生成精美剪辑视频',
          '让数字人代替本人出镜，快速助力营销人打造IP',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-three.png',
      },

    ],
  },
  {
    pathUrl: '/solution/lead-conversion',
    pathName: '线索跟进转化',
    title: '智能化线索管理，提升转化效率',
    dataInfo: [
      {
        direction: 'left',
        title: '线上商城',
        subtitle: '支撑全域商品线上交易的增收利器',
        link: '/index',
        list: [
          '支持自有商品、微信小店商品、京东商品等多商品体系',
          '商城支持关联分销体系&会员体系',
          '线上交易&线下门店承接-双轮驱动增长',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-fouer.png',
      },
      {
        direction: 'right',
        title: '电子物料库',
        subtitle: '内容驱动的智能营销引擎',
        link: '/index',
        list: [
          '多样化传播物料，覆盖拓客全场景',
          '一物一码多途径管理，便捷溯源优化',
          '细颗粒度数据采集，获取轨迹挖掘潜客',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
      },
      {
        direction: 'left',
        title: '营销活动',
        subtitle: '优秀活动一键复用，玩法多样快速组合',
        link: '/index',
        list: [
          '7000+高品质活动模板，一键套用快速获客',
          '5级玩法嵌套满足复杂营销需求，契合95%的营销节点',
          '"拖-拉-拽"快速配置活动，上线效率提升4倍以上',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-three.png',
      },
      {
        direction: 'right',
        title: '积分商城',
        subtitle: '分享过程激励，低成本拉新促活',
        link: '/index',
        list: [
          '不同角色设置多样任务和积分体系，分层促活',
          '用户转发裂变进行积分激励，提高用户粘性',
          '商城上架实物、卡券等多样化礼品，用户可进行积分兑换，提升客户活跃度',
          '结合分享报备、全民营销、案场服务、预约场馆，扩展更多业务场景',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/precipitate-two.png',
      },
    ],
  },
  {
    pathUrl: '/solution/marketing-automation',
    pathName: '自动化营销',
    title: '重构社群生态，激活私域价值',
    dataInfo: [
      {
        direction: 'left',
        title: '社群运营',
        subtitle: '专业化社群管理系统，驱动运营效率跃升',
        link: '/index',
        list: [
          '活动引擎：支持 8 大类型社群活动，一键发起高效执行 ',
          '流量沉淀：社群相册 / 动态发帖 / 企微导流，构建公私域流量联动枢纽 ',
          '异业联盟：跨界资源整合，打通周边生活矩阵',
        ],
        image: require('@/assets/img/产品功能图片/品牌运营中枢.png'),
      },
      {
        direction: 'right',
        title: '企微运营',
        subtitle: '来源打标分配 + 智能群触达 + 数据可视优化沟通全流程',
        link: '/index',
        list: [
          '客户来源信息打标，快速分配精细化运营',
          '多种智能化群运营能力，自动触达定向客群',
          '群聊数据可视化分析，有效优化运营效率',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/precipitate-one.png',
      },
      // {
      //   direction: 'left',
      //   title: '精准筛选目标客户',
      //   subtitle: '强大的客户定向能力，基于多维度细分，精准筛选并聚焦赋能销售',
      //   link: '/index',
      //   list: [
      //     '基于客户行为、属性、标签、来源等条件进行客户细分，精准筛选目标客户',
      //     '基于目标客户的细分，集中营销成本与精力在目标客户，赋能销售',
      //   ],
      //   image:
      //     require('@/assets/img/产品功能图片/精准筛选目标客户.png'),
      // },
    ],
  },
  {
    pathUrl: '/solution/community-miniprogram',
    pathName: '社群小程序',
    title: '以"品牌展示、社群活动、线上商城、圈层裂变"四大场景，构建高客单价业务增长引擎',
    dataInfo: [
      {
        title: '品牌展示',
        desc: '以"品牌展示、社群活动、线上商城、圈层裂变"四大场景，构建高客单价业务增长引擎',
        subDataInfo: [
          {
            direction: 'left',
            title: '品牌展示',
            subtitle: '多维立体品牌空间，强化用户认知与归属感',
            list: [
              '官方小程序品牌展览，统一流量收口，集成VR/视频/图文等多维展示',
              '内置项目展示、预约、线上咨询等功能，实时相应客户需求',
              '全埋点追踪行为，捕捉真实用户意向',
            ],
            image: require('@/assets/img/产品功能图片/品牌运营中枢.png'),
          },
          {
            direction: 'right',
            title: '产品视频',
            subtitle: '动态化项目展示，降本提效+裂变传播',
            list: [
              '短视频上下滑动播放，挂载预约物料，支持私信顾问与分享功能',
              '用动态视频直观呈现项目亮点，降低客户理解成本',
              '一键分享助力项目扩散，扩大传播范围，挖掘潜在客群',
            ],
            image: require('@/assets/img/产品功能图片/产品视频.png'),
          },
        ]
      },
      {
        title: '社群活动',
        desc: '以灵活配置+互动运营，构建私域社群生态',
        subDataInfo: [
          {
            direction: 'left',
            title: '社群搭子',
            subtitle: '以灵活配置+互动运营，构建私域社群生态',
            list: [
              '支持按项目需求创建主题社群，自定义名称、归属、简介、封面，关联企微群码与入群规则',
              '可维护群相册、活动、帖子、成员信息，支持入群审核，精准把控社群质量（活动营销需额外采购）',
              '开放客户互动权限，支持发帖、看帖、点赞、活动参与、社群分享，激活私域活力，沉淀客户关系',
            ],
            image: require('@/assets/img/产品功能图片/社群搭子.png'),
          },
          {
            direction: 'right',
            title: '活动中心',
            subtitle: '用高吸引力玩法激活参与，数据驱动营销提效',
            list: [
              '集成助力抽奖、报名、集赞、拼团等热门活动，关联优惠券与超级落地页，串联多活动场景',
              '支持签到核销，提供ROI数据分析，精准追踪活动效果',
              '通过趣味互动激活客户参与欲，以数据优化策略，让营销投入精准触达目标客群',
            ],
            image: require('@/assets/img/产品功能图片/社群活动中心.png'),
          },
        ]
      },
      {
        title: '线上商城',
        desc: '支持全域商品线上交易的增收利器',
        subDataInfo: [
          {
            direction: 'left',
            title: '商城中心',
            subtitle: '支持全域商品线上交易的增收利器',
            list: [
              '支持上线自有商品、微信小店商品、京东商品等多商品体系',
              '商城支持关联分销体系&会员体系',
              '线上交易&线下门店承接-双轮驱动增长',
            ],
            image: require('@/assets/img/产品功能图片/商城中心.png'),
          },
          {
            direction: 'right',
            title: '优惠券',
            subtitle: '灵活配置+场景联动，撬动消费转化',
            list: [
              '自定义满减/折扣/代金券，设置时间、门槛规则，适配拉新/回流/促销场景',
              '关联活动、商城，叠加抽奖/拼团玩法，打造"领券-用券-复购"闭环',
              '追踪领取/使用数据，分析客群偏好，为营销迭代找方向',
            ],
            image: require('@/assets/img/产品功能图片/优惠券.png'),
          },
          {
            direction: 'left',
            title: '会员积分',
            subtitle: '以"权益互通+分层运营+分享裂变"为驱动，构建私域会员增长闭环，激活会员价值',
            list: [
              '不同角色可独立配置专属会员体系，可通过积分兑换礼品、参与社群活动，持续活跃会员',
              '推出储值加赠、生日特权等专属活动，强化身份尊贵感',
              '设计"分享得积分""拉新升级会员"玩法，借助社交链扩大流量',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/precipitate-two.png',
          },
        ]
      },
      {
        title: '圈层裂变',
        desc: '搭建私域分销网络，人人都是"营销员"',
        subDataInfo: [
          {
            direction: 'right',
            title: '注册合伙人',
            subtitle: '搭建私域分销网络，人人都是"营销员"',
            list: [
              '支持创建"全民经纪人"体系，自定义合伙人层级、规则，快速布局二级分销网络',
              '老客/员工推荐新用户注册，自动绑定关系，实现"推荐-转化-分佣"闭环',
              '把客户变成"合伙人"，借助社交链扩大推广半径，低成本挖掘潜在客群',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-two.png',
          },
          {
            direction: 'left',
            title: '佣金结算',
            subtitle: '分佣结算清晰透明，让"推广动力"持续在线',
            list: [
              '交易完成后，系统自动计算合伙人佣金（含一级、二级分佣），无需人工对账',
              '支持佣金快速提取，实时查看收益明细，让合伙人"看得见、拿得到"',
              '后台清晰记录分佣数据，关联推广行为，既保障权益又便于运营分析',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-six.png',
          },
        ]
      },
    ],
  },
  {
    pathUrl: '/solution/private-domain-growth',
    pathName: '私域资产持续增值',
    title: '实现精准客户画像与自动化营销策略',
    dataInfo: [
      {
        direction: 'left',
        title: '360客户台账',
        subtitle: '精准识别客户意向，辅助营销决策',
        link: '/index',
        list: [
          '基于任务系统+AI云Call，智能快捷识别线索意向',
          '洞悉客群属性和行为，精准预测客户生命周期阶段',
          '基于全渠道数据埋点，生成360度描摹，还原客户真实画像',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/operations-three.png',
      },
      {
        direction: 'right',
        title: '营销自动化',
        subtitle: '基于客户行为洞察的智能培育',
        link: '/index',
        list: [
          '整合多营销渠道触达客户，实现关键场景自动牵引 ',
          '通过内容物料获取访问轨迹，自动描摹客户画像',
          '基于客户属性细分定向，精准筛选目标客群',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/operations-four.png',
      },
      {
        direction: 'left',
        title: '销售BI',
        subtitle: '为一线提供真实业务指导意义的营销BI',
        link: '/index',
        list: [
          '集成全域数据，打造1+3可视化分析平台，支撑营销决策',
          '数据联动过滤及下钻，分析系统性强',
          '一次建模，长期复用，数据处理效率大大提升',
          '满足团队协作、项目管理、数据协作等多重场景',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/insight-one.png',
      },

    ],
  },
  {
    pathUrl: '/solution/smart-scene',
    pathName: '智慧案场',
    footerSubTitle: '案场服务流程标准化，强化销售过程管控',
    title: '案场服务流程标准化，完成线上交易闭环，强化销售过程管控',
    dataInfo: [
      {
        direction: 'left',
        title: '电子签到',
        subtitle: '更规范、更高效的案场接待模式',
        link: '/index',
        list: [
          '统一来访入口，快速完成全渠道客户登记及判客',
          '无归属客户自动排序，手机端实时通知对应置业顾问',
          '自动关联案场跟客模块，避免漏客藏客',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-one.png',
      },
      {
        direction: 'right',
        title: '客户台账',
        subtitle: '一站式客户管理中心',
        link: '/index',
        list: [
          '多渠道线索一站集成，全方位识别客户',
          '多维度标签画像，定向圈选精准运营',
          '自定义线索视图，客户分层运营',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-eight.png',
      },
      {
        direction: 'left',
        title: '智能工牌',
        subtitle: '一线销讲看得到，案场盘客更高效',
        link: '/index',
        list: [
          'AI还原更真实客户画像，盘客更高效 ',
          '复制销冠能力模型，让优秀销售经验充分流淌',
          '总结分析客户关注点和敏感点，销讲策略迭代升级',
          '自动匹配用户，开机即用流畅体验，极大提升录音覆盖率',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-six.png',
      },
      {
        direction: 'right',
        title: 'GPT盘客',
        subtitle: '给顾问靠谱的跟进建议',
        link: '/index',
        list: [
          'GPT自动生成沟通总结，真实还原客户需求和抗性',
          '智能生成详细跟进建议，优化销售行动策略',
          'AI助手提示关键信息，复盘随时随地、高效便捷',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-nine.png',
      },
    ],
  },
  {
    pathUrl: '/solution/transaction-manager',
    pathName: '交易管理',
    title: '数字化案场交易，助力交易各环节智慧升级',
    dataInfo: [
      {
        direction: 'left',
        title: '在线开盘',
        subtitle: '解决传统开盘所有问题，快速提升开盘效率和规模',
        link: '/index',
        list: [
          '流程简单，极速筹备，最快一天即可开盘',
          '足不出户，微信选房，一键开抢效率飙升',
          '数据看板，实时查看，去化情况一目了然',
          '安全稳定，系统强大，为全流程保驾护航',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-five.png',
      },
      {
        direction: 'right',
        title: '房源管理',
        subtitle: '在线轻松管理所有房源',
        link: '/index',
        list: [
          '房型/楼层/个户信息细分呈现，房源详情清晰呈现',
          '楼盘销售进展直观查看，实时调整销控策略',
          '房源定/调价方案快速制定，折扣方案轻松配置',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-two.png',
      },
      {
        direction: 'left',
        title: '回款管理',
        subtitle: '回款进度实时掌握，回款效率快速提升',
        link: '/index',
        list: [
          '自动生成应收款项，快速生成催款任务 ',
          '欠款催收提醒，加快回款效率',
          '快速收款，自动生成收款单据',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-four.png',
      },
      {
        direction: 'right',
        title: '审批管理',
        subtitle: '各类业务审批在线通关',
        link: '/index',
        list: [
          '自由定义流程走向，多管理员共同协作',
          '各组织间互不干扰，多条审批并行流转',
          '集中管控流程数据，审批记录条条可查',
          '层层节点环环相扣，流转进度实时通知',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-seven.png',
      },
    ],
  },
  {
    pathUrl: '/solution/precise-customer',
    pathName: '全渠道获客',
    title: '内容驱动，实现策销渠一体，千人千面提升全渠道获客体验',
    dataInfo: [
      {
        direction: 'left',
        title: '线上售楼处',
        subtitle: '快速构建线上营销阵地',
        link: '/index',
        list: [
          '全方位小程序线上展厅，移动看房、购房一体化',
          '更懂用户使用习惯和需求，实现品牌价值的极致展示',
          '销售工作台10+种拓客物料，快速覆盖拓客全场景',
        ],
        image:  'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/online-hall-one.png',
      },
      {
        direction: 'right',
        title: '广告投放',
        subtitle: '投放获客的一站式提效解决方案',
        link: '/index',
        list: [
          '主流投放平台全覆盖，打通公域-私域获客通路',
          '线索统一收口，一站式管理所有客源',
          '效果智能分析，提升投放精准度及费效',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-one.png',
      },
      {
        direction: 'left',
        title: '营销活动',
        subtitle: '优秀活动一键复用，玩法多样快速组合',
        link: '/index',
        list: [
          '7000+高品质活动模板，一键套用快速获客',
          '5级玩法嵌套满足复杂营销需求，契合95%的营销节点',
          '"拖-拉-拽"快速配置活动，上线效率提升4倍以上',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-three.png',
      },
      {
        direction: 'right',
        title: '电子物料库',
        subtitle: '内容驱动的智能营销引擎',
        link: '/index',
        list: [
          '多样化传播物料，覆盖拓客全场景',
          '一物一码多途径管理，便捷溯源优化',
          '细颗粒度数据采集，获取轨迹挖掘潜客',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
      },

    ],
  },
  {
    pathUrl: '/solution/customer-precipitate',
    pathName: '社群运营',
    title: '结合活动+权益，通过场景引导驱动全民转化，提升客户资源利用率',
    footerSubTitle: '多场景驱动全民转化，快速提升客户资源利用率',
    dataInfo: [
      {
        direction: 'left',
        title: '积分商城',
        subtitle: '分享过程激励，低成本拉新促活',
        link: '/index',
        list: [
          '不同角色设置多样任务和积分体系，分层促活',
          '用户转发裂变进行积分激励，提高用户粘性',
          '商城上架实物、卡券等多样化礼品，用户可进行积分兑换，提升客户活跃度',
          '结合分享报备、全民营销、案场服务、预约场馆，扩展更多业务场景',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/precipitate-two.png',
      },
      {
        direction: 'right',
        title: '会员体系',
        subtitle: '精准激励，梯次权益维系核心角色',
        link: '/index',
        list: [
          '不同角色可独立配置专属会员体系，权益与权利更精准',
          '会员可享受福利、生日礼、购房特权，增加身份尊贵感',
          '可结合积分商城、社群，构建更具费效比的获客方式',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/precipitate-five.png',
      },
      {
        direction: 'left',
        title: '企微运营',
        subtitle: '圈层增长转化解决方案',
        link: '/index',
        list: [
          '客户来源信息打标，快速分配精细化运营',
          '多种智能化群运营能力，自动触达定向客群',
          '群聊数据可视化分析，有效优化运营效率',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/precipitate-one.png',
      },
    ],
  },
  {
    pathUrl: '/solution/intelligent-operate',
    pathName: '营销自动化',
    title: '千万级存量客户分层及自动化运营，全面把握意向加速客户转化',
    dataInfo: [
      {
        direction: 'left',
        title: '营销自动化',
        subtitle: '基于客户行为洞察的智能培育',
        link: '/index',
        list: [
          '整合多营销渠道触达客户，实现关键场景自动牵引 ',
          '通过内容物料获取访问轨迹，自动描摹客户画像',
          '基于客户属性细分定向，精准筛选目标客群',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/operations-four.png',
      },
      {
        direction: 'right',
        title: '客户分析平台',
        subtitle: '精准识别客户意向，辅助营销决策',
        link: '/index',
        list: [
          '基于任务系统+AI云Call，智能快捷识别线索意向',
          '洞悉客群属性和行为，精准预测客户生命周期阶段',
          '基于全渠道数据埋点，生成360度描摹，还原客户真实画像',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/operations-three.png',
      },
      {
        direction: 'left',
        title: 'AI云Call',
        subtitle: '智能外呼高效识别与盘活客户',
        link: '/index',
        list: [
          '简单设置呼叫任务，批量处理上万单沉睡客户',
          '快速筛选客户意向，价值客户一键报备',
          '减少硬件及人力投入，大大降低洗客成本',
        ],
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/operations-five.png',
      },
 
    ],
  },
  {
    pathUrl: '/solution/data-insight',
    pathName: '管理驾驶舱',
    title: '汇总全域数据可视化查看，助力企业以数据驱动业绩增长',
    footerSubTitle: '全域数据可视化汇总查看，助力企业以数据驱动业绩增长',
    dataInfo: [
      {
        direction: 'left',
        title: 'BI看板',
        subtitle: '为一线提供真实业务指导意义的营销BI',
        link: '/index',
        list: [
          '集成全域数据，打造1+3可视化分析平台，支撑营销决策',
          '数据联动过滤及下钻，分析系统性强',
          '一次建模，长期复用，数据处理效率大大提升',
          '满足团队协作、项目管理、数据协作等多重场景',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/insight-one.png',
      },
      {
        direction: 'right',
        title: '数据报表',
        subtitle: '自助式的BI报表平台',
        link: '/index',
        list: [
          'N个多样化报表模板，营销链路多节点支撑业务决策',
          '灵活拖拽式操作，自由添加、管理数据，大幅降低分析难度，提高汇报沟通效率',
          '各类型数据自定义导出，查询结果图表化，释放分析能力',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/insight-three.png',
      },
    ],
  },
  {
    pathUrl: '/solution/community-miniprogram',
    pathName: '社群小程序',
    footerTitle: '社群小程序',
    banner: [
      {
        titleDesc: '重构社群生态，激活私域价值',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/big-banner-community.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/min-big-banner-community.png',
        title: '社群小程序',
        pathTitle: '社群小程序',
        desc: '​​​重构社群生态，激活私域价值。打造"用户——品牌——本地生活"三位一体的长效增长引擎，实现流量→留量→销量的闭环。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/visual-display',
    pathName: '数字沙盘',
    title: '楼盘方寸间，看房零局限',
    footerSubTitle: '快速构建线上营销阵地，打造流畅的买房卖房体验',
    dataInfo: [
      {
        direction: 'left',
        title: 'UE5智慧大屏',
        subtitle: '沉浸式互动体验',
        link: '/index',
        list: [
          '游戏级别的互动感，带给用户超越真实的场景',
          '城市扫描+GIS技术真实还原城市环境',
          '任意漫游查看空间，实时渲染模拟自然光影',
          '虚拟场景帮助开发商提前预售，缩减营销周期',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/visual-three.png',
      },
      {
        direction: 'right',
        title: 'iPad移动售楼系统',
        subtitle: '行走的售楼处',
        link: '/index',
        list: [
          '多元内容形式，满足案场与购房客户深度沟通',
          '随时随地沉浸式看房、选房、游览社区环境体',
          '可置入导出多样化媒体材料，制作成本更低，更新便捷',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/digital-sand-table-two.png',
      },
      {
        direction: 'left',
        title: '微沙盘',
        subtitle: '可视化场景营销利器',
        link: '/index',
        list: [
          '项目价值点极致演绎，充分满足客户看房需求',
          '一键扫码带走微沙盘，扩大传播渠道，降低获客成本',
          '打破低转化率，增大线上流量转化及客户粘性',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/visual-one.png',
      },
      {
        direction: 'right',
        title: '云创编辑器',
        subtitle: '一站式营销物料生产平台',
        link: '/index',
        list: [
          '可视化开发平台，聚焦内容创意，集成流程一目了然',
          '海量优秀案例模板，覆盖多类型地产应用场景',
          '跨平台应用技术，满足平板、大屏、移动端、一体机多平台内容制作',
          '八大内容模块，满足不同营销节点推广需求',
        ],
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/visual-four.png',
      },
    ],
  },
  {
    pathUrl: '/solution/community-miniprogram',
    pathName: '社群小程序',
    footerTitle: '社群小程序',
    banner: [
      {
        titleDesc: '重构社群生态，激活私域价值',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/big-banner-community.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/min-big-banner-community.png',
        title: '社群小程序',
        pathTitle: '社群小程序',
        desc: '​​​重构社群生态，激活私域价值。打造"用户——品牌——本地生活"三位一体的长效增长引擎，实现流量→留量→销量的闭环。',
        link: '/index',
      },
    ],
  },
];

// 营销云数据配置
export const marketingCloudDataList = [
  {
    pathUrl: '/solution/marketing-cloud',
    pathName: '营销云',
    title: '全渠道营销管理平台，让营销更智能、更高效',
    dataInfo: [
      {
        title: '投放中心',
        desc: '全平台投放管理中枢，让投流获客"高效又可控"',
        subDataInfo: [
          {
            direction: 'left',
            title: '投放中心',
            subtitle: '全平台投放管理中枢，让投流获客"高效又可控"',
            list: [
              '打通腾讯广告、百度营销、巨量引擎、小红书聚光等主流平台，一个平台管理多渠道投放',
              '线索统一收口、投放报表一键导出，自动整合多平台效果数据，直观对比平台差异，优化投放策略更高效',
              '实时监测投放数据，智能分析"触达-转化"链路，效果智能分析，持续提升投流精准度与获客ROI',
            ],
            image: require('@/assets/img/产品功能图片/全渠道获客.png'),
          },
        ]
      },
      {
        title: '内容中心',
        desc: '内容驱动的智能营销引擎',
        subDataInfo: [
          {
            direction: 'right',
            title: '内容中心',
            subtitle: '内容驱动的智能营销引擎',
            list: [
              '多样化传播物料，覆盖拓客全场景',
              '一物一码多途径管理，便捷溯源优化',
              '细颗粒度数据采集，获取轨迹挖掘潜客',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
          },
        ]
      },
      {
        title: '渠道中心',
        desc: '全渠道拓客运营中枢，让 "溯源 - 判客 - 成交" 高效贯通',
        subDataInfo: [
          {
            direction: 'left',
            title: '渠道中心',
            subtitle: '全渠道拓客运营中枢，让 "溯源 - 判客 - 成交" 高效贯通',
            list: [
              '精准溯源，打通抖音、小红书、微信等渠道数据，客户来源自动标记、全链路数据可追溯，明确各渠道贡献',
              '连接公域及私域拓客渠道统一管理，规范对接流程，高效识别高意向客群，实现拓客流程标准化',
              '支持多渠道拓客物料便捷分发，集成分析渠道数据，助力企业依据数据优化成交结构',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-four.png',
          },
        ]
      },
      {
        title: '数据管理',
        desc: '智能营销培育，实现 "触达 - 洞察 - 运营" 自动化',
        subDataInfo: [
          {
            direction: 'right',
            title: '营销画布',
            subtitle: '智能营销培育，实现 "触达 - 洞察 - 运营" 自动化',
            list: [
              '整合多渠道，关键场景自动触达，可视化画布串联运营流程',
              '追踪行为轨迹，动态更新画像，让策略精准匹配需求',
              '按属性与行为智能分群，定向培育，提升转化效能',
            ],
            image: require('@/assets/img/产品功能图片/高效转化闭环.png'),
          },
          {
            direction: 'left',
            title: '客户台账',
            subtitle: '全周期客户管理中枢，支撑营销精准运营',
            list: [
              '覆盖客户来源、状态、归属等信息，整合营销云全生命周期数据，一个台账掌握客户全维度动态',
              '依托任务系统与 AI 技术，自动识别线索意向，生成 360° 客户画像，精准预判生命周期阶段，为营销决策提供数据支撑',
              '支持手动录入、备注报备、公客池管理等操作，多维度筛选盘点客户，实现信息记录与运营执行衔接，提升管理效率',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-eight.png',
          },
          {
            direction: 'right',
            title: '管理报表',
            subtitle: '业务数据智能中枢，驱动营销决策高效落地',
            list: [
              'BI看板集成全域数据，打造可视化分析平台，一次建模长期复用，数据处理效率倍增，支撑营销决策精准输出',
              '覆盖客户行为、成交业务等多维度数据看板，满足团队协作、项目管理等场景，多视角呈现业务状态',
              '数据报表支持个性化模板、灵活维度配置，自定义导出数据，降低分析难度，提升汇报效率与决策响应速度',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/insight-three.png',
          },
        ]
      },
      {
        title: '交易管理',
        desc: '全流程交易管控，让回款、审批、结算高效协同',
        subDataInfo: [
          {
            direction: 'left',
            title: '交易管理',
            subtitle: '全流程交易管控，让回款、审批、结算高效协同',
            list: [
              '回款智能驱动：自动生成收款项、催缴任务，借欠款催办提醒加速资金回笼，实时掌握回款进度',
              '审批在线贯通：自定义流程，支持多管理员协作、多条件并行流转，集中管控数据，审批轨迹可查',
              '结算便捷直达：在线快速完成款项结算，智能POS 收款后自动关联数据，生成单据，贯通交易全链路，提升运营效率',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-four.png',
          },
        ]
      },
    ],
  },
];

// 单独配置crm页面,因为他多了一层嵌套
export const crmDataList = [
  {
    pathUrl: '/solution/omnichannel-acquisition',
    pathName: '全渠道获客',
    title: '全域精准获客，构建高质量线索池',
    dataInfo: [
      {
        title: '公域投放',
        desc: '全渠道精准触达潜在客户',
        subDataInfo: [
          {
            direction: 'left',
            title: '公域投放',
            subtitle: '投放获客的一站式提效解决方案',
            list: [
              '主流投放平台全覆盖，打通公域 - 私域获客通路',
              '线索统一收口，一站式管理所有客源',
              '效果智能分析，提升投放精准度及提效',
            ],
            image: require('@/assets/img/产品功能图片/AIGC内容获客.png'),
          },
        ]
      },
      {
        title: '自媒体获客',
        desc: '全渠道精准触达潜在客户',
        subDataInfo: [
          {
            direction: 'right',
            title: '自媒体获客',
            subtitle: '内容驱动线索增长的智能工具箱',
            list: [
              'AIGC内容获客：快速批量化文案创作，爆文信手拈来',
              'AI短视频获客：AI智能剪辑+矩阵自动分发，可批量多人快速传播',
              'AI视频工厂：1部手机5分钟快速生成精美视频，赋能销售IP',
            ],
            image: require('@/assets/img/产品功能图片/AI短视频.png'),
          },
        ]
      },
      {
        title: '私域裂变',
        desc: '全渠道精准触达潜在客户',
        subDataInfo: [
          {
            direction: 'left',
            title: '私域裂变',
            subtitle: '微信私域营销',
            list: [
              '支持分享裂变追踪，完成私域精准渗透',
              '盖微信多场景，渗透微信社群、朋友圈、微信好友',
            ],
            image: require('@/assets/img/产品功能图片/AI视频工厂-真人.png'),
          },
        ]
      },

      {
        title: '全民营销',
        desc: '全渠道精准触达潜在客户',
        subDataInfo: [
          {
            direction: 'right',
            title: '全民营销',
            subtitle: '实现规模化低成本获客',
            list: [
              '建立经纪人工作台，报备到结佣全流程可视化',
              '搭建经纪人自裂变网络，实现二级分佣',
              '在线快速结佣，激发经纪人推客动力',
              '分享推荐积分赚积分，实现过程激励',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/channel-manage-three.png',
          },

        ]
      },
    ],
  },
  {
    pathUrl: '/solution/lead-conversion',
    pathName: '线索跟进转化',
    title: '全域精准获客，构建高质量线索池',
    dataInfo: [
      {
        title: '自动分客',
        desc: '智能化线索管理，提升转化效率',
        subDataInfo: [
          {
            direction: 'left',
            title: '自动分客',
            list: [
              '无需手动导表，自动分配降低人员成本',
              '实时客资流转，缩短分配时间周期',
              '智能分配客资，支持配置多种分配规则',
              '减少人工介入，保证客资分配公平',
            ],
            image:  'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-three.png',
          },
          {
            direction: 'right',
            title: '线索跟进SOP',
            subtitle: '线索自动归集+智能分配+分级跟进+专属转化全链路，一体化运营',
            list: [
              '线索分配：广告线索自动归集，智能分配线索，数据追踪线索的转化分析',
              '线索跟进：外呼触达，标记线索意向等级，按阶段管理',
              '线索转化：针对广告投放线索，进行专属流程搭建，执行人工外呼任务转化',
            ],
            image: require('@/assets/img/产品功能图片/线索跟进SOP.png'),
          },
        ]
      },
      {
        title: '智能工牌',
        desc: '智能化线索管理，提升转化效率',
        subDataInfo: [
  
          
          {
            direction: 'left',
            title: '智能工牌',
            subtitle: '一线销讲100%记录，100%分析AI盘客更高效',
            list: [
              '100%记录沟通内容，实时上传录音信息，自动匹配对话人',
              '100%分析，客户分析生成智能标签，构筑用户画像，盘客更高效',
              '销售分析，复制销冠能力模型，让优秀销讲经验充分流淌',
              '基于Aidee交叉分析，总结客户关注点和抗性点，给出营销策略',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/field-six.png',
          },
        ]
      },
      // {
      //   title: '自动化标签&画像',
      //   desc: '自动化标签&画像',
      //   subDataInfo: [
      //     // {
      //     //   direction: 'right',
      //     //   title: '客户分析平台',
      //     //   list: [
      //     //     '基于任务系统+AI云Call，智能快捷识别线索意向',
      //     //     '洞悉客群属性和行为，精准预测客户生命周期阶段',
      //     //     '基于全渠道数据埋点，生成360度描摹，还原客户真实画像',
      //     //   ],
      //     //   image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/operations-three.png',
      //     // },
      //     // {
      //     //   direction: 'right',
      //     //   title: '自动化标签&画像',
      //     //   subtitle: '智能识别客户意向，助力销售客观决策',
      //     //   list: [
      //     //     '三种算法模型，全面分析客户画像，根据标签生成多种画像统计',
      //     //     'AI助手生成智能标签，标签支持追溯来源，自动描摹，销售仅需查看和确认',
      //     //     'Aidee结合营销的全场景和全数据，可实现客户多维度交叉分析，协助销售更客观决策',
      //     //   ],
      //     //   image: require('@/assets/img/产品功能图片/客户画像智能体.png'),
      //     // },
      //     // {
      //     //   direction: 'right',
      //     //   title: 'AI智能识别自动描摹',
      //     //   list: [
      //     //     '文案文案文案',
      //     //     '文案文案文案',
      //     //     '文案文案文案',
      //     //   ],
      //     //   image: require('@/assets/img/产品功能图片/AI智能识别自动描摹.png'),
      //     // },
      //     // {
      //     //   direction: 'left',
      //     //   title: '客户分析 Agent',
      //     //   list: [
      //     //     '文案文案文案',
      //     //     '文案文案文案',
      //     //     '文案文案文案',
      //     //   ],
      //     //   image: require('@/assets/img/产品功能图片/客户分析 Agent.png'),
      //     // },
      //   ]
      // },
    ],
  },
  {
    pathUrl: '/solution/crm',
    pathName: '销冠CRM',
    title: '快速构建线上营销阵地，打造流畅的买房卖房体验',
    dataInfo: [
      {
        title: '拓客利器',
        desc: '连接流量平台，打通公私域，更低成本获客',
        subDataInfo: [
          {
            direction: 'left',
            title: '电子名片',
            subtitle: '聚合内容 + 强化 IP + 私域追踪，让专业形象"一站成型、精准触达"',
            list: [
              '多平台（抖音/小红书 ）内容聚合，一个主页装下所有专业作品',
              '自定义简历、案例、标签，打造专属 IP 符号，快速让客户记住你',
              '微信生态分享（链接/长图/二维码 ）+ 实时访客追踪，形象展示直接驱动私域转化',
            ],
            image: require('@/assets/img/产品功能图片/电子名片.png'),
          },
          {
            direction: 'right',
            title: '电子物料库',
            subtitle: '内容驱动的智能营销引擎',
            list: [
              '海报、文章、视频等多样化传播物料，覆盖拓客全场景',
              '可生成一物一码，多途径管理便捷查看客户来源',
              '精细化数据采集，可获取客户轨迹挖掘潜在客户',
            ],
            image:  'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/channel-manage-one.png',
          },
          {
            direction: 'left',
            title: '营销活动',
            subtitle: '优秀活动一键复用，玩法多样快速组合',
            list: [
              '7000+高品质活动模板，一键套用快速获客',
              '5级玩法嵌套满足复杂营销需求，契合95%的营销节点',
              '"拖·拉·拽"快速配置活动，上线效率提升4倍以上',
            ],
            image:  'https://cdn.ideamake.cn/sw-pc/images/web3.0/accurate-customer-three.png',
          },
          {
            direction: 'right',
            title: '发抖音',
            subtitle: '抖音营销闭环工具，让流量"发布即转化"',
            list: [
              '支持多物料（视频/图文 ）一键发抖音，不用切换平台，发布效率拉满',
              '接入抖音直播小风车，流量线索直导入私域，保障流量承接价值',
              '私信自动回复抓意向、群聊卡片引导留电话，沉淀私域资产',
            ],
            image: require('@/assets/img/产品功能图片/发抖音.png'),
          },
        ]
      },
      {
        title: 'AI应用',
        desc: 'AI驱动内容量产，让爆文"批量出、随手得"',
        subDataInfo: [
          {
            direction: 'left',
            title: 'AI数字人',
            subtitle: '1 部手机 5 分钟快速出片，让销售 IP 视频 "量产 + 出圈"',
            list: [
              '套用模板即可生成精美视频，数字人替代真人出镜，省去拍摄、剪辑成本',
              '无需写文案、拍素材（零 NG ）、剪视频，AI 包揽全流程，把精力聚焦 "传播获客"',
              '用数字人打造专属销售形象，批量输出专业、统一的内容，强化客户对品牌 / 销售的认知，驱动转化',
            ],
            image:  require('@/assets/img/产品功能图片/AI视频工厂-数字人.png'),
          },
          {
            direction: 'right',
            title: 'AI内容创作',
            subtitle: 'AI 驱动内容量产，让爆文 "批量出、随手得"',
            list: [
              'AIGC内容生成快速批量化文案创作，爆文信手拈来',
              '高效的智能体编辑器，支持小红书笔记、短视频脚本、直播脚本等新媒体文案创作',
              '蒲公英矩阵打法，内容生成后推送至顾问待办，可一键发布/后台批量发布至多媒体平台',
            ],
            image: require('@/assets/img/产品功能图片/AIGC内容获客.png'),
          },
          {
            direction: 'left',
            title: 'AIdee',
            subtitle: 'AI 驱动客户洞察，让营销决策"精准又高效"',
            list: [
              '整合客户数据，支持画像、行为、需求交叉分析，数据一键洞察，打破信息孤岛',
              '自动生成跟进建议、竞品应对说辞，生成可执行营销策略，销售更客观决策',
              '适配接待、回访、运营全流程，定制化输出洞察，把数据转化为"业绩增长力"',
            ],
            image:  require('@/assets/img/产品功能图片/客户分析 Agent.png'),
          },
        ]
      },
      {
        title: '客户管理',
        desc: '实时跟客闭环，让客户运营 "0 遗漏、快响应"',
        subDataInfo: [
          {
            direction: 'right',
            title: '跟客助手',
            subtitle: '实时跟客闭环，让客户运营 "0 遗漏、快响应"',
            list: [
              '全方位通知客户实时动态，需求相应更及时',
              '未读任务反复提醒，盘客跟客动作无遗漏',
              '销冠跟客模型，更多自动化客户管理经验指导',
            ],
            image:  'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-six.png',
          },
          {
            direction: 'left',
            title: '客户洞察',
            subtitle: '用AI穿透数据，还原客户真实需求画像',
            list: [
              'AI智能算法深度解析客户行为，精准识别真实需求与购买能力',
              '全渠道数据埋点，生成360°虚拟画像，还原客户真实画像',
              '从客户动态到可落地策略，用数据驱动营销动作精准落地',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-four.png',
          },
        ]
      },
      {
        title: '团队协作',
        desc: '数据驱动经营，让业务指标"看得见、管得住"',
        subDataInfo: [
          {
            direction: 'right',
            title: '招募经纪人',
            subtitle: '全民分销基建，实现"招人 - 管⼈- 提效"闭环',
            list: [
              '一键招募可生成海报快速分享，借社交圈拓经纪人渠道，破招人触达窄难题',
              '实时看旗下经纪人运营、业绩数据，无需挨个沟通，团队情况秒掌握',
              '自动统计分销贡献，为激励、评估提供数据，激活分销动力',
            ],
            image:  require('@/assets/img/产品功能图片/招募经纪人.png'),
          },
          {
            direction: 'left',
            title: '经营看板',
            subtitle: '数据驱动经营，让业务指标"看得见、管得住"',
            list: [
              '整合短视频/直播转化、全链路业务数据，从内容进客到业绩成果，一层看板穿透经营全环节',
              '实时呈现销售、抖音等多维度数据，有效复盘前端业务成果',
              '支持业务任务、组织评估系统化管理，让经营策略不跑偏',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-eleven.png',
          },
          {
            direction: 'right',
            title: '销售排行榜',
            subtitle: '数据排行驱动，激活团队成长力',
            list: [
              '多维排行，覆盖物质、荣誉、流量、客资激励，自动生成团队与个人榜单',
              '实时动态更新数据，排行关联荣誉奖励，直观呈现贡献价值，激发成长动力',
              '穿透个人数据，借排行洞察差距、补足短板，驱动团队持续进化',
            ],
            image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-twelve.png',
          },
        ]
      },
    ],
  }
]



export const bannerList = [
  {
    pathUrl: '/solution/crm',
    pathName: '销冠CRM',
    footerTitle: '销冠CRM',
    banner: [
      {
        titleDesc: '赋能超级个体，成就百万销冠',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/big-banner-crm.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/min-big-banner-crm.png',
        title: '销冠CRM | 更智能的营销CRM',
        pathTitle: '销冠CRM',
        desc: '连接流量平台快速获取线索，通过贯穿客户生命周期的洗客、识客、跟客、转化，为一线销售提供更先进的作战工具，助力销冠之路',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/marketing-cloud',
    pathName: '营销云',
    footerTitle: '营销云',
    banner: [
      {
        titleDesc: '全渠道营销管理平台，让营销更智能、更高效',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '营销云 | 全渠道营销管理平台',
        pathTitle: '营销云',
        desc: '打通全渠道营销链路，从投放获客到客户管理，从内容营销到数据分析，提供一站式营销管理解决方案，让营销更智能、更高效',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/channel-manage',
    pathName: '渠道管理',
    footerTitle: '全渠道高效管理方案',
    banner: [
      {
        titleDesc: '规范管理、精准判客、渠道风控',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '全渠道高效管理方案',
        pathTitle: '渠道管理',
        desc: '连接内外拓客渠道统一管理，规范渠道对接流程高效判客转化，多种拓客物料便捷分发，渠道数据集成分析，助力企业挖掘最优渠道配比',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/member-marketing',
    pathName: '会员营销',
    footerTitle: '会员营销',
    banner: [
      {
        titleDesc: '精准识别、个性推荐、生命周期管理',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '会员营销',
        pathTitle: '会员营销',
        desc: '渠道智能会员营销增长闭环，整合驱动 + 数据赋能 + 价值裂变体系，提升会员生命周期价值，实现可持续增长。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/industry/automotive',
    pathName: '汽车行业解决方案',
    footerTitle: '汽车行业解决方案',
    banner: [
      {
        titleDesc: '数字化营销转型，智慧驱动汽车销售新时代',
        image: require('@/assets/img/行业解决方案banner/汽车解决方案banner.png'),
        minImage: require('@/assets/img/行业解决方案banner/移动适配-汽车.png'),
        title: '汽车经销商数字化营销解决方案',
        pathTitle: '汽车行业解决方案',
        desc: '面向汽车经销商提供全链路数字化营销解决方案，从线上展厅、获客营销到客户管理，助力汽车行业实现数字化转型升级，提升销售效率与客户体验',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/industry/real-estate',
    pathName: '房地产行业解决方案',
    footerTitle: '房地产行业解决方案',
    banner: [
      {
        titleDesc: '数字化营销转型，智慧驱动地产销售新时代',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '房地产企业数字化营销解决方案',
        pathTitle: '房地产行业解决方案',
        desc: '面向房地产企业提供全链路数字化营销解决方案，从获客营销到案场管理，助力房地产行业实现数字化转型升级，提升销售效率与客户体验',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/industry/healthcare',
    pathName: '大健康行业解决方案',
    footerTitle: '大健康行业解决方案',
    banner: [
      {
        titleDesc: '数字化营销转型，智慧驱动健康产业新发展',
        image: require('@/assets/img/行业解决方案banner/大健康解决方案banner.png'),
        minImage: require('@/assets/img/行业解决方案banner/移动适配-健康.png'),
        title: '大健康企业数字化营销解决方案',
        pathTitle: '大健康行业解决方案',
        desc: '面向大健康企业提供全链路数字化营销解决方案，从专业内容营销到客户健康管理，助力健康产业实现数字化转型升级，提升服务质量与客户信任',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/industry/education',
    pathName: '教育行业解决方案',
    footerTitle: '教育行业解决方案',
    banner: [
      {
        titleDesc: '数字化营销转型，智慧驱动教育产业新发展',
        image: require('@/assets/img/行业解决方案banner/教育解决方案banner.png'),
        minImage: require('@/assets/img/行业解决方案banner/移动适配-教育.png'),
        title: '星火燎原数字化精准营销系统',
        pathTitle: '教育行业解决方案',
        desc: '一站式教培营销解决方案：整合前端获客、中端智能运营、后端高效管理，全链路提升转化率与ROI',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/industry/home-decoration',
    pathName: '家装行业解决方案',
    footerTitle: '家装行业解决方案',
    banner: [
      {
        titleDesc: '数字化营销转型，智慧驱动家装产业新发展',
        image: require('@/assets/img/行业解决方案banner/家装解决方案banner.png'),
        minImage: require('@/assets/img/行业解决方案banner/移动适配-家装.png'),
        title: '家装企业数字化营销解决方案',
        pathTitle: '家装行业解决方案',
        desc: '面向家装企业提供全链路数字化营销解决方案，从3D设计展示到项目管理，助力家装行业实现数字化转型升级，提升服务质量与客户满意度',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/omnichannel-acquisition',
    pathName: '全渠道获客',
    footerTitle: '全渠道获客',
    banner: [
      {
        titleDesc: '全渠道覆盖、低费效比、高转化率',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '全域获客',
        pathTitle: '全渠道获客',
        desc: '通过Ai获客、信息流广告、直播获客、全面营销等功能打通线上线下，实现策销渠一体，帮助企业全域精准获取高质量线索。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/lead-conversion',
    pathName: '线索跟进转化',
    footerTitle: '线索跟进转化',
    banner: [
      {
        titleDesc: '智能化线索管理，提升转化效率',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '线索管理',
        pathTitle: '线索识别',
        desc: '建立完整的线索跟进体系，通过智能分配、自动提醒、跟进记录等功能，确保每个线索得到及时有效的跟进，显著提升线索转化率和销售效率',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/marketing-automation',
    pathName: '自动化营销',
    footerTitle: '私域运营',
    banner: [
      {
        titleDesc: '老带新、口碑传播、裂变增长',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '私域运营',
        pathTitle: '自动化营销',
        desc: '重构社群生态，激活私域价值。打造"用户——品牌——本地生活"三位一体的长效增长引擎，实现流量→留量→销量的闭环。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/private-domain-growth',
    pathName: '私域资产持续增值',
    footerTitle: '数据运营',
    banner: [
      {
        titleDesc: '精准识别、个性推荐、生命周期管理',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '数据运营',
        pathTitle: '私域资产持续增值',
        desc: '基于全渠道数据洞察，构建智能标签体系，实现精准客户画像与自动化营销策略，驱动私域流量高效转化与价值最大化。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/smart-scene',
    pathName: '智慧案场',
    banner: [
      {
        titleDesc: '签到溯源、销冠复制、案场提效',
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-four.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-four.png',
        title: '智慧案场数字化方案',
        pathTitle: '智慧案场',
        desc: '赋能客户报备-到访-溯源-判客-交易全流程，支持线上到成交闭环精细化管理，帮助企业高效规范案场服务及销售过程，快速实现案场数字化升级',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/transaction-manager',
    pathName: '交易管理',
    banner: [
      {
        titleDesc: '低成本、易搭建、更先进',
        image:
        'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/big-banner-transaction-manager.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/min-banner-transaction-manager.png',
        title: '房地产轻量化ERP系统',
        pathTitle: '交易管理',
        desc: '数字化案场交易管理，赋能线上交易、房源管控、快速回款、审批流转、在线开盘，实时掌控交易各环节进度，助力交易效率快速提升',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/precise-customer',
    pathName: '全渠道获客',
    banner: [
      {
        titleDesc: '全渠道覆盖、低费效比、高转化率',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-one.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-one.png',
        title: '全渠道精准获客方案',
        pathTitle: '全渠道获客',
        desc: '通过Ai获客、信息流广告、直播获客、全面营销等功能打通线上线下，实现策销渠一体，帮助企业全域精准获取高质量线索。',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/customer-precipitate',
    pathName: '社群运营',
    banner: [
      {
        titleDesc: '',
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-five.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-five.png',
        title: '业主社群运营方案',
        pathTitle: '社群运营',
        desc: '基于社群运营场景，灵活运用积分权益+营销活动+全民营销等多重玩法，挖掘核心业主等KOC，以老带新实现裂变级增长，让成交客户成为口碑传播客户',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/intelligent-operate',
    pathName: '营销自动化',
    banner: [
      {
        titleDesc: '一体化管理、营销自动化、智能标签',
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-three.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-three.png',
        title: '客户智能培育方案',
        pathTitle: '营销自动化',
        desc: '打通多端流量平台统一管理公域线索，自动生成客户标签及画像，一客一策分层自动化运营，助力销售实现强效能运营转化',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/data-insight',
    pathName: '管理驾驶舱',
    banner: [
      {
        titleDesc: '最符合业务逻辑，报表统一、灵活生成查看',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-six.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-six.png',
        title: '数据管控赋能方案',
        pathTitle: '管理驾驶舱',
        desc: '采集汇总全域数据，BI看板可视化呈现成交结构、客户情况、服务流程等多维口径，实时分析自动预警，为前端业务提供决策指导',
        link: '/index',
      },
    ],
  },
  // {
  //   pathUrl: '/solution/sales-empowerment',
  //   pathName: '销售赋能',
  //   banner: [
  //     {
  //       titleDesc: '抖音高效拓客、拉通公私域、智能销售助手',
  //       image:
  //         'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-seven.png',
  //       minImage:
  //         'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-seven.png',
  //       title: '知屋｜一线销售爱用好用的业务伙伴',
  //       desc: '连接抖音等流量平台快速公域拓客，多平台客户线索及动态集成，自动画像分层运营，智能助手辅助打标、带看提醒，为一线业务提供更先进的作战工具',
  //       link: '/index',
  //     },
  //   ],
  // },
  {
    pathUrl: '/solution/community-miniprogram',
    pathName: '社群小程序',
    footerTitle: '小程序',
    banner: [
      {
        titleDesc: '重构社群生态，激活私域价值',
        image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-two.png',
        minImage: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-two.png',
        title: '客户运营小程序',
        pathTitle: '社群小程序',
        desc: '以一体化数字化工具覆盖"项目展示-客户互动-智能服务体验-私域沉淀"全场景，用精准功能解决获客难、转化慢、粘性低的行业痛点',
        link: '/index',
      },
    ],
  },
  {
    pathUrl: '/solution/visual-display',
    pathName: '数字沙盘',
    footerTitle: '移动售楼处',
    banner: [
      {
        titleDesc: '极致展示、实时交互、流畅体验',
        image:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/big-banner-eight.png',
        minImage:
          'https://cdn.ideamake.cn/sw-pc/images/web3.0/min-banner-eight.png',
        title: '一站式可视化的场景营销方案',
        desc: '结合VR、UE等前沿视觉技术，打破时空限制，通过三维场景、VR连接带看为客户提供全新视觉体验，助力企业提升楼盘效率、拓客获客边界',
        link: '/index',
      },
    ],
  },
];
